// Mock data for Hair Extensions Training Academy

export const courses = [
  {
    id: '1',
    title: 'Hook and Latch Hair Extension Technician',
    duration: '1 Day',
    cost: '£750 + VAT',
    accreditation: 'CPD Accredited',
    description: 'This unique hair extension technique was designed by Diane Shawe in 2009 to work with clients who had originally experienced hair loss and damage but needed hair extensions to assist them during their hair growth.',
    learningOutcomes: [
      'Preparing bespoke wefts',
      'Applying, maintain and remove hair extensions',
      'Blending & shaping hair extensions',
      'Work on live model'
    ],
    courseBreakdown: 'Full day intensive hands-on training with kit included. Final look session (2 hours).'
  },
  {
    id: '2',
    title: 'Learn 3 Techniques Boot-camp (Option 1)',
    duration: '1 Day',
    cost: '£510 + VAT',
    accreditation: 'CPD Accredited',
    description: 'Comprehensive one-day boot-camp training for hair extension technicians. Learn three essential hair extension techniques in an intensive single-day format.',
    learningOutcomes: [
      'Cornrow & Braiding',
      'Integrated Weave',
      'Professional Clip-ins'
    ],
    courseBreakdown: '1 day intensive boot-camp covering 3 popular techniques with hands-on practice. Qualify as Hair Extension Technician.'
  },
  {
    id: '3',
    title: 'Learn 3 Techniques Boot-camp (Option 2)',
    duration: '1 Day',
    cost: '£510 + VAT',
    accreditation: 'CPD Accredited',
    description: 'Alternative one-day boot-camp focusing on advanced application methods including strand-by-strand and micro rings.',
    learningOutcomes: [
      'Strand by Strand (glue gun)',
      'Pre tips (make your own)',
      'Single micro rings'
    ],
    courseBreakdown: '1 day intensive boot-camp with alternative techniques and practical application. Qualify as Hair Extension Technician.'
  },
  {
    id: '4',
    title: 'Hair Extension Technician - Learn 4 Techniques (Option 1)',
    duration: '2 Days',
    cost: '£650 + VAT',
    accreditation: 'CPD Accredited',
    description: 'Two-day comprehensive training covering three popular hair extension techniques. Perfect for aspiring technicians looking to build a solid foundation.',
    learningOutcomes: [
      'Cornrow & Braiding',
      'Integrated Weave',
      'Professional Clip-ins',
      'Micro-ring track'
    ],
    courseBreakdown: '2 day intensive covering 3 essential techniques with hands-on practice and qualification as 3 Hair Extension Technique Technician.'
  },
  {
    id: '5',
    title: 'Hair Extension Technician - Learn 4 Techniques (Option 2)',
    duration: '2 Days',
    cost: '£650 + VAT',
    accreditation: 'CPD Accredited',
    description: 'Alternative 2-day course focusing on different application methods including strand-by-strand and micro rings.',
    learningOutcomes: [
      'Strand by Strand (glue gun)',
      'Pre tips (make your own)',
      'Single micro rings',
      'Micro-ring track'
    ],
    courseBreakdown: '2 day intensive with alternative techniques and practical application. Qualify as 3 Hair Extension Technique Technician.'
  },
  {
    id: '6',
    title: 'Hair Loss Enhancement Consultant',
    duration: '3 Days',
    cost: '£2,600 + VAT (Non-Residential) / £3,100 + VAT (Residential)',
    accreditation: 'CPD Accredited',
    description: 'A hair loss enhancement consultant can assist with a hair makeover that will help the client present a natural looking set of hair by offering five professional techniques. Kit included.',
    learningOutcomes: [
      'Crowning Glory: For thinning hair on top',
      'Hair2Skin: For clients with 70%+ hair loss',
      'Net Weave: For patchy alopecia',
      'Lace Wig: For hair line damage or complete makeovers',
      'Cornrow & integrate hair support techniques',
      'Working on live models'
    ],
    courseBreakdown: '3 days intensive with residential kit included. Learn to protect, enhance, and maintain clients\' natural hair. Qualification: Hair Loss Hair Enhancement Consultant.'
  },
  {
    id: '7',
    title: 'Hair Extension Consultant - Learn 10 Techniques',
    duration: '5 Days Residential or 8 Weeks Non-Residential',
    cost: '£3,500 + VAT (Non-Residential) / £4,500 + VAT (Residential)',
    accreditation: 'CPD Accredited',
    description: 'Become a hair extension consultant specialist in 10 or more hair extension techniques. A consultant can assist a variety of clients by supplying a solution to their hair problem.',
    learningOutcomes: [
      'Cornrow & Braiding',
      'Integrated Weave',
      'Hook and Latch',
      'Professional Clip-ins',
      'Micro-ring track',
      'Strand by Strand',
      'Pre tips',
      'Single micro rings',
      'Crowning Glory',
      'Blending & Shaping'
    ],
    courseBreakdown: 'Comprehensive training with hotel accommodation & breakfast (residential), course manuals, work on 3 live models, and full professional kit.'
  },
  {
    id: '8',
    title: 'Cranial Prosthesis Consultant',
    duration: '3 Days',
    cost: '£1,600 + VAT',
    accreditation: 'CPD Accredited',
    description: 'Medical-grade hair loss solutions including cranial prosthesis consultation and insurance reporting. Qualified to compile 12-Month Cranial Prosthesis Reports for insurance claims, NHS funding, or charitable support.',
    learningOutcomes: [
      'Conduct professional hair loss consultations',
      'Identify, measure, and colour-match for bespoke cranial prostheses',
      'Differentiate between medical-grade wigs, toppers, and integration systems',
      'Produce official reports for insurance and funding bodies',
      'Provide emotional and ethical support',
      'Integrate service profitably into practice'
    ],
    courseBreakdown: 'Day 1: Medical foundations & ethics. Day 2: Consultation, customisation & costing. Day 3: Report writing, claims & business growth.'
  },
  {
    id: '9',
    title: 'Hair Extension Trainer - Learn 12 Techniques',
    duration: '7 Days',
    cost: '£7,500 + VAT',
    accreditation: 'Fully Accredited',
    description: 'Learn 12 techniques and train others in your area to develop professional skills. Fully accredited with impressive revenue streams and long-term career potential.',
    learningOutcomes: [
      'Master 12 hair extension techniques',
      'Teaching methodologies',
      'Course delivery and assessment',
      '2 day observation and assessment',
      'Full professional trainers kit',
      'Trainers students course material',
      'Work with real students'
    ],
    courseBreakdown: '5 days residential includes hotel, breakfast, working on live models, training real students for assessment. Requires 2 years hair extension experience.'
  },
  {
    id: '10',
    title: 'Custom Lace Wig Consultant - Make Your Own Wig',
    duration: '1-3 Days',
    cost: '£350 + VAT (1 Day) / £1,650 + VAT (2 Days) / £2,650 + VAT (3 Days)',
    accreditation: 'CPD Accredited',
    description: 'Learn how to make custom lace wigs as a technician, consultant, trainer or for yourself. Ideal opportunity to develop a new career making hair systems for a wide cross-section of clients.',
    learningOutcomes: [
      'Learn how to measure the head',
      'Learn how to source different caps',
      'Learn different templates for hair placement and styling',
      'Learn how to advise about system care',
      'Learn how to semi-permanently fit the system'
    ],
    courseBreakdown: '1 Day: Make & Wear Your Own Wig. 2 Days: Start Your Own Business. 3 Days: Become A Trainer. Qualification: Custom Hair System Wig Consultant.'
  },
  {
    id: '11',
    title: 'Eyebrow Threading',
    duration: '1 Day',
    cost: '£295 + VAT',
    accreditation: 'CPD Accredited',
    description: 'Threading is an ancient eyebrow shaping and hair removal technique which originated from Asia. Celebrities prefer this method for shaping perfect eyebrows.',
    learningOutcomes: [
      'Methods of threading',
      'Types of hair on the body',
      'Contra Indications',
      'Products to use'
    ],
    courseBreakdown: '1 day course includes kit. Learn this celebrity-favorite technique for perfect eyebrow shaping.'
  },
  {
    id: '12',
    title: 'Gel Nail Technician',
    duration: '1 Day',
    cost: '£350 + VAT',
    accreditation: 'CPD Accredited',
    description: 'The Gel Nail business has taken off. Many clients are now turning to Gel Nails as they make the nail stronger and the polished look lasts longer.',
    learningOutcomes: [
      'Preparing the Nail',
      'Nail Extensions application',
      'Application procedure',
      'Removal Technique',
      'Course Theory'
    ],
    courseBreakdown: '1 day course includes kit. Learn professional gel nail application and extensions.'
  }
];

export const testimonials = [
  {
    id: '1',
    type: 'youtube',
    videoId: 'dQw4w9WgXcQ',
    name: 'Sarah Johnson',
    title: 'Graduate Success Story',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
  },
  {
    id: '2',
    type: 'youtube',
    videoId: 'dQw4w9WgXcQ',
    name: 'Michelle Roberts',
    title: 'From Student to Franchise Owner',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg'
  },
  {
    id: '3',
    type: 'tiktok',
    videoUrl: 'https://www.tiktok.com/@needahairmakeover',
    name: 'Emma Davis',
    title: 'Hair Loss Transformation'
  }
];

export const achievements = [
  'HBA Awards 2025 - UK Top 50 Salon',
  'BTG National Awards Winner',
  'GB Beauty Awards Winner',
  'UK Hair Awards Winner',
  '4100+ Students Trained Since 2006',
  'Globally Accredited Training Provider'
];

export const externalLinks = {
  franchise: 'https://needahairmakeoverfranchise.co.uk',
  salon: 'https://needahairmakeover.com',
  store: 'https://needahairmakeover.co',
  blog: 'https://needahairmakeover.blog'
};

export const socialLinks = {
  youtube: 'https://youtube.com/@needahairmakeover',
  tiktok: 'https://www.tiktok.com/@needahairmakeover',
  facebook: 'https://facebook.com/needahairmakeover2',
  twitter: 'https://x.com/needa_makeover',
  pinterest: 'https://pinterest.com/needahairmakeover',
  linkedin: 'https://linkedin.com/showcase/needahairmakeoverfranchise',
  instagram: 'https://instagram.com/needahairmakeover'
};

export const contactInfo = {
  address: 'National Training Centre',
  phone: '+44 20 3051 4338',
  email: 'info@hairextensionstraining.academy',
  lat: 52.5081,
  lng: -2.0847
};

// Mock admin data
export const mockEnquiries = [
  {
    id: '1',
    name: 'Jane Smith',
    email: 'jane@example.com',
    phone: '07123456789',
    courseId: '1',
    courseName: 'Hair Loss Consultant',
    message: 'Interested in the next available course dates',
    status: 'Applied',
    date: '2025-01-15'
  },
  {
    id: '2',
    name: 'Mary Johnson',
    email: 'mary@example.com',
    phone: '07987654321',
    courseId: '4',
    courseName: 'Hair Extensions Technician',
    message: 'Looking to start my own business',
    status: 'Accepted',
    date: '2025-01-10'
  },
  {
    id: '3',
    name: 'Lisa Brown',
    email: 'lisa@example.com',
    phone: '07456789123',
    courseId: '2',
    courseName: 'Cranial Prosthesis Consultant',
    message: 'Have previous experience in hair styling',
    status: 'Started',
    date: '2025-01-05'
  }
];
// Blog Posts Data
export const blogPosts = [
  {
    id: '1',
    slug: 'train-as-hair-extension-technician',
    title: 'Train as a Hair Extension Technician: Learn 3–23 In-Demand Techniques',
    image: 'https://static.prod-images.emergentagent.com/jobs/a235b419-86b2-4667-9fd0-c39959dca4de/images/319f4e78b8de78aa48f9916fa4d6d63dc936a0c6c2073dccd0021da6908c7fc4.png',
    excerpt: 'Training as a hair extension technician is the fastest way to enter one of the most profitable areas of the beauty industry.',
    content: `Training as a hair extension technician, Consultant, Trainer or Cranial Prosthesis Consultant is the fastest way to enter one of the most profitable areas of the beauty industry. By learning 3–12 professional techniques, you can begin working with clients almost immediately, offering services that deliver instant results and high client satisfaction. Technician training focuses on safe application, hair health, blending, and aftercare, giving you the confidence to work on real clients from day one.

This route is ideal for beginners, mobile technicians, or beauty professionals looking to add a high-value service without committing to long training periods. With demand for extensions continuing to grow, qualified technicians are needed in salons, on-set, and for private clients. A technician qualification allows you to start earning quickly, build experience, and progress to advanced consultant or trainer levels when ready.

As a consultant, you're trained to assess hair health, recommend suitable solutions, and deliver bespoke results rather than one-size-fits-all applications. This level of qualification opens doors to higher pricing, repeat clientele, and professional recognition. Consultants are trusted specialists, often working with salons, private clients, and media professionals. With hair loss and thinning on the rise, clients are actively seeking qualified consultants who can offer safe, long-term solutions. This training is ideal for those serious about building a sustainable, respected career.

Hair prosthesis training takes your skills beyond extensions into life-changing solutions. As a Hair Prosthesis Consultant, you learn how to measure, design, fit, and maintain wigs, toppers, toupees, and bespoke hair systems. This work supports insurance reports, clients experiencing hair loss from medical conditions, genetics, or trauma. This training teaches you how to compile detailed 12-month reports required by insurance companies, NHS referrals, and charitable funding bodies.

The opportunity to working in Fashion, Film, Theatre & Media is real. Hair professionals trained in extensions and hair systems are in constant demand across fashion, film, theatre, television, and photography.

In the UK alone, over 15 million people experience hair loss, according to the NHS—and the number is rising. Despite this, there are not enough qualified technicians and consultants to meet demand. This gap presents a major opportunity for trained professionals.

Training opens the door to business ownership. Many graduates go on to open specialist salons, private consulting practices, or join franchise opportunities. With the right skills, systems, and support, you can build a business focused on high-value services rather than high volume. Specialist salons attract loyal clients, premium pricing, and long-term sustainability.

Whether you want independence or the backing of a proven model, training is the first step toward business freedom.`,
    tags: ['HairExtensionTechnician', 'BeautyTraining', 'NewCareer', 'HairExtensions'],
    date: '2026-01-25'
  },
  {
    id: '2',
    slug: 'become-hair-extension-consultant',
    title: 'Become a Hair Extension Consultant: Learn 10 Professional Techniques',
    image: 'https://static.prod-images.emergentagent.com/jobs/a235b419-86b2-4667-9fd0-c39959dca4de/images/bcdc90966b22a5ad4ba8d84d196fc99903972298ff2671989e2251ec460e66a7.png',
    excerpt: 'Consultant-level training is designed for those who want to stand out as true experts in the hair extension industry.',
    content: `Consultant-level training is designed for those who want to stand out as true experts. Learning 10 advanced hair extension techniques allows you to work with a wider range of clients, hair types, and challenges. As a consultant, you're trained to assess hair health, recommend suitable solutions, and deliver bespoke results rather than one-size-fits-all applications.

This level of qualification opens doors to higher pricing, repeat clientele, and professional recognition. Consultants are trusted specialists, often working with salons, private clients, and media professionals. With hair loss and thinning on the rise, clients are actively seeking qualified consultants who can offer safe, long-term solutions.

This training is ideal for those serious about building a sustainable, respected career.`,
    tags: ['HairExtensionConsultant', 'AdvancedTraining', 'BeautyBusiness', 'CareerUpgrade'],
    date: '2026-01-24'
  },
  {
    id: '3',
    slug: 'train-hair-prosthesis-consultant',
    title: 'Train as a Hair Prosthesis Consultant: Wigs, Toppers & Hair Systems',
    image: 'https://static.prod-images.emergentagent.com/jobs/a235b419-86b2-4667-9fd0-c39959dca4de/images/d697fa6781e8e2bce176abca41ee54eb8aab7d59c0388aa110f86d73f22aa976.png',
    excerpt: 'Hair prosthesis training takes your skills beyond extensions into life-changing solutions.',
    content: `Hair prosthesis training takes your skills beyond extensions into life-changing solutions. As a Hair Prosthesis Consultant, you learn how to measure, design, fit, and maintain wigs, toppers, toupees, and bespoke hair systems.

This work supports insurance reports, clients experiencing hair loss from medical conditions, genetics, or trauma. It is a highly respected and emotionally rewarding specialism, blending technical skill with compassion and professionalism.

Qualified consultants can work in salons, clinics, or independently, offering non-surgical solutions that restore confidence and dignity. With increasing demand for medical-grade and custom hair systems, this qualification places you in a niche with less competition and higher value services.`,
    tags: ['HairProsthesis', 'WigConsultant', 'HairLossSolutions', 'SpecialistTraining'],
    date: '2026-01-23'
  },
  {
    id: '4',
    slug: 'cranial-prosthesis-reports-insurance-funding',
    title: 'Learn to Create Cranial Prosthesis Reports for Insurance & Funding',
    image: 'https://static.prod-images.emergentagent.com/jobs/a235b419-86b2-4667-9fd0-c39959dca4de/images/fb5408535c25f57d8c384c3fe9b9f64258a1b4357517aa134e11e6837eb46e87.png',
    excerpt: 'Cranial prosthesis reporting is a powerful skill that elevates you from technician to trusted professional.',
    content: `Cranial prosthesis reporting is a powerful skill that elevates you from technician to trusted professional. This training teaches you how to compile detailed 12-month reports required by insurance companies, NHS referrals, and charitable funding bodies.

You'll learn consultation documentation, medical terminology, fitting schedules, and maintenance planning. Clients rely on qualified professionals to support their funding applications, making this a highly valuable service.

Very few hair professionals are trained in this area, which means strong demand and limited competition. Adding this skill not only increases your income potential but positions you as a serious authority in hair loss support.`,
    tags: ['CranialProsthesis', 'InsuranceReports', 'HairLossCare', 'ProfessionalTraining'],
    date: '2026-01-22'
  },
  {
    id: '5',
    slug: 'working-fashion-film-theatre-media',
    title: 'Working in Fashion, Film, Theatre & Media',
    image: 'https://static.prod-images.emergentagent.com/jobs/a235b419-86b2-4667-9fd0-c39959dca4de/images/55deb5c2212135cb1fb52f0561260f2f9b566c59611e0c6e14273f66694e4e82.png',
    excerpt: 'Hair professionals trained in extensions and hair systems are in constant demand across fashion, film, theatre, and television.',
    content: `Hair professionals trained in extensions and hair systems are in constant demand across fashion, film, theatre, television, and photography. Productions require reliable specialists who understand precision, continuity, and performance under pressure.

Training gives you the technical foundation and professional credibility needed to work backstage, on-set, or with models and performers. From editorial shoots to stage productions, hair specialists play a vital role in visual storytelling.

This career path offers variety, creativity, and the chance to work with high-profile clients while building an impressive portfolio.`,
    tags: ['FashionHair', 'FilmAndTheatre', 'MediaCareers', 'HairProfessionals'],
    date: '2026-01-21'
  },
  {
    id: '6',
    slug: 'supporting-clients-cancer-illness-hair-damage',
    title: 'Supporting Clients Through Cancer, Ill Health & Hair Damage',
    image: 'https://static.prod-images.emergentagent.com/jobs/a235b419-86b2-4667-9fd0-c39959dca4de/images/82f6526a24400f52950f35a9b2305061db6914d9bd37fa6d371da483f5c608cb.png',
    excerpt: 'Working with clients experiencing hair loss due to cancer treatment, illness, or severe damage is one of the most meaningful roles in the industry.',
    content: `Working with clients experiencing hair loss due to cancer treatment, illness, or severe damage is one of the most meaningful roles in the industry. Specialist training equips you to work safely, sensitively, and ethically with vulnerable clients.

You'll learn how to offer non-invasive solutions that protect remaining hair while restoring confidence. This work goes far beyond aesthetics—it changes lives.

Demand for trained professionals in this area continues to grow as awareness and diagnosis increase.`,
    tags: ['HairLossSupport', 'CancerCare', 'NonSurgicalHair', 'ConfidenceRestoration'],
    date: '2026-01-20'
  },
  {
    id: '7',
    slug: 'working-with-all-hair-types-textures-ages',
    title: 'Working With All Hair Types, Textures & Ages',
    image: 'https://static.prod-images.emergentagent.com/jobs/a235b419-86b2-4667-9fd0-c39959dca4de/images/93e491b7606d0451db5527257c3dd44ed7bd14b183da2180109c354074982799.png',
    excerpt: 'Professional training prepares you to work confidently with all hair types, textures, and age groups.',
    content: `Professional training prepares you to work confidently with all hair types, textures, and age groups. From fine, ageing hair to textured, curly, or chemically treated hair, understanding diversity is essential.

Clients expect personalised solutions that respect their hair type and lifestyle. Training ensures you can adapt techniques safely and effectively, expanding your client base and reputation.

Inclusivity is no longer optional—it's a professional standard.`,
    tags: ['AllHairTypes', 'InclusiveBeauty', 'ProfessionalSkills', 'HairTraining'],
    date: '2026-01-19'
  },
  {
    id: '8',
    slug: 'build-career-take-anywhere-world',
    title: 'Build a Career You Can Take Anywhere in the World',
    image: 'https://static.prod-images.emergentagent.com/jobs/a235b419-86b2-4667-9fd0-c39959dca4de/images/7b1b6d1615173def321489a1f620051f29d44e2e5e77a8e6a3fa0f851f5fdeb5.png',
    excerpt: 'Hair extension and hair loss skills are globally transferable. Once qualified, you can work anywhere.',
    content: `Hair extension and hair loss skills are globally transferable. Once qualified, you can work anywhere—salons, private studios, cruise ships, international events, or as a mobile specialist.

This flexibility makes it an ideal career for those seeking freedom, relocation opportunities, or remote independence.

With consistent global demand, your skills remain relevant regardless of location or economy.`,
    tags: ['WorkAnywhere', 'GlobalCareer', 'HairIndustry', 'FlexibleLifestyle'],
    date: '2026-01-18'
  },
  {
    id: '9',
    slug: 'growing-market-hair-loss-15-million-uk',
    title: 'A Growing Market: Hair Loss Affects Over 15 Million People in the UK',
    image: 'https://static.prod-images.emergentagent.com/jobs/a235b419-86b2-4667-9fd0-c39959dca4de/images/ab9211752b27dceb2c4e84b5f24132eeb6c7d5fb73d3d6b403c265fd1b1f678a.png',
    excerpt: 'In the UK alone, over 15 million people experience hair loss—and the number is rising.',
    content: `In the UK alone, over 15 million people experience hair loss, according to the NHS—and the number is rising. Despite this, there are not enough qualified technicians and consultants to meet demand.

This gap presents a major opportunity for trained professionals. Clients are actively searching for safe, non-surgical solutions delivered by qualified experts.

Entering the industry now means positioning yourself ahead of the curve in a rapidly expanding market.`,
    tags: ['HairLossUK', 'GrowingMarket', 'CareerOpportunity', 'SpecialistSkills'],
    date: '2026-01-17'
  },
  {
    id: '10',
    slug: 'start-own-specialist-salon-consultancy-franchise',
    title: 'Start Your Own Specialist Salon, Consultancy or Franchise',
    image: 'https://static.prod-images.emergentagent.com/jobs/a235b419-86b2-4667-9fd0-c39959dca4de/images/3a7e3507ce66ac5c203ab095a9b448ddcdec342d811bbde85105ab8a53cb1cae.png',
    excerpt: 'Training opens the door to business ownership. Many graduates go on to open specialist salons or join franchise opportunities.',
    content: `Training opens the door to business ownership. Many graduates go on to open specialist salons, private consulting practices, or join franchise opportunities.

With the right skills, systems, and support, you can build a business focused on high-value services rather than high volume. Specialist salons attract loyal clients, premium pricing, and long-term sustainability.

Whether you want independence or the backing of a proven model, training is the first step toward business freedom.`,
    tags: ['SpecialistSalon', 'HairBusiness', 'FranchiseOpportunity', 'EntrepreneurLife'],
    date: '2026-01-16'
  }
];
